var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8446_3641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 2.5009C14.3829 2.28203 14.6428 2.10842 14.9287 1.98996C15.2147 1.87151 15.5212 1.81055 15.8307 1.81055C16.1403 1.81055 16.4468 1.87151 16.7327 1.98996C17.0187 2.10842 17.2785 2.28203 17.4974 2.5009C17.7163 2.71977 17.8899 2.97961 18.0083 3.26558C18.1268 3.55154 18.1878 3.85804 18.1878 4.16757C18.1878 4.4771 18.1268 4.7836 18.0083 5.06956C17.8899 5.35553 17.7163 5.61537 17.4974 5.83424L6.2474 17.0842L1.66406 18.3342L2.91406 13.7509L14.1641 2.5009Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8446_3641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/edit-new.e09def96b8bd52977ba7a23ae2c1873b.svg";
export { ForwardRef as ReactComponent };